import { css, html, LitElement } from "lit"
import "@luminecence/composants/BoutonsSegmente"
import "@luminecence/composants/BoutonSegmente"
import "./PageEchangesPokemons.js"
import "./PagePokemonsAEchanger.js"

export default class PageEchanges extends LitElement {
  static properties = { mode: { type: String }, idCommunaute: { type: String } }

  static styles = css`
        :host {
            display: flex;
            flex-direction: column;
            gap: 2rem;
            padding-top: 2rem;
        }
    `

  constructor() {
    super()
    /** @type {"recherche" | "echange"} */
    this.mode = "recherche"
    this.idCommunaute = ""
  }

  render() {
    return html`<p-boutons-segmente @evenementSelectionBoutonSegmente=${(event) => (this.mode = event.detail.valeur)}>
            <p-bouton-segmente valeur="recherche" ?selectionne=${this.mode === "recherche"} texte="Recherche"></p-bouton-segmente>
            <p-bouton-segmente valeur="echange" ?selectionne=${this.mode === "echange"} texte="Echange"></p-bouton-segmente>
        </p-boutons-segmente>
        
        ${this.mode === "recherche" ? html`<p-page-echanges-pokemons .idCommunaute=${this.idCommunaute}></p-page-echanges-pokemons>` : html`<p-page-pokemons-a-echanger .idCommunaute=${this.idCommunaute}></p-page-pokemons-a-echanger>`}
        `
  }
}
customElements.define("p-page-echanges", PageEchanges)
